// extracted by mini-css-extract-plugin
module.exports = {"details-rich-text":"ServiceDetails_details-rich-text__mK07p","dark":"ServiceDetails_dark__nk03Y","tick-2":"ServiceDetails_tick-2__dqzSZ"};